import { fillOrbitals, type SubshellOccupancy } from "@/lib/orbitalDiagram";

interface Props {
  subshells: SubshellOccupancy[];
}

const L_NAMES = ["s", "p", "d", "f"];

export default function OrbitalDiagram({ subshells }: Props) {
  return (
    <div className="space-y-2.5">
      {subshells.map((sub) => {
        const boxes = fillOrbitals(sub.l, sub.electrons);
        return (
          <div key={sub.label} className="flex items-center gap-3">
            <span className="font-mono text-xs font-semibold text-foreground w-10 shrink-0">
              {sub.label}
            </span>
            <div className="flex gap-1">
              {boxes.map((arrows, i) => (
                <OrbitalBox key={i} arrows={arrows} />
              ))}
            </div>
            <span className="font-mono text-[10px] text-muted-foreground ml-auto">
              {sub.electrons}e⁻
            </span>
          </div>
        );
      })}
      <p className="text-[10px] text-muted-foreground pt-1.5 border-t border-border leading-relaxed">
        Each box is one orbital (holds up to 2 electrons). Arrows follow Hund's
        rule: unpaired first, then paired with opposite spins.
      </p>
    </div>
  );
}

function OrbitalBox({ arrows }: { arrows: number }) {
  return (
    <div className="w-7 h-7 border border-border bg-background rounded-sm flex items-center justify-center gap-[1px] relative">
      {arrows >= 1 && (
        <span
          className="text-primary font-bold text-base leading-none"
          aria-hidden="true"
        >
          ↑
        </span>
      )}
      {arrows >= 2 && (
        <span
          className="text-primary/70 font-bold text-base leading-none"
          aria-hidden="true"
        >
          ↓
        </span>
      )}
    </div>
  );
}
